import { RootState } from "@store/store";
import { useSelector } from "react-redux";

interface Portal {
  key: string;
  title: string;
  description: string;
}

const cdrsPortal = {
  key: "CDRS",
  title: "CDRS",
  description: "Cash Deposit Reporting System",
  permissions: [
    "Billing Services",
    "File Transfer Services",
    "Scheduler Services",
    "CDRS Services",
    "Batch Services",
    "Organization Services",
  ],
};

const useServicePortal = () => {
  const access = useSelector((state: RootState) => state.user.access);

  // const hasCDRSAccess = access.some((a) =>
  //   cdrsPortal.permissions.includes(a.serviceName)
  // );

  //const allowedCDRSPortals: Portal[] = hasCDRSAccess ? [cdrsPortal] : [];

  const cmsAccess = access.find(
    (a) =>
      a.serviceCode === "CMS" &&
      !cdrsPortal.permissions.includes(a.serviceName) &&
      a.serviceName !== "EUMS Service"
  );

  const allowedCMSPortals: Portal[] = cmsAccess
    ? [
        {
          key: "CMS",
          title: cmsAccess.serviceName,
          description: cmsAccess.serviceDescription,
        },
      ]
    : [];

  const allowedOtherPortals: Portal[] = access
    .filter(
      (a) =>
        !cdrsPortal.permissions.includes(a.serviceName) &&
        a.serviceCode !== "CMS" &&
        a.serviceCode !== "EUMS"
    )
    .map((a) => ({
      key: a.serviceCode,
      title: a.serviceName,
      description: a.serviceDescription,
    }));

  const allowedPortals: Portal[] = [
    ...allowedCMSPortals,
    ...allowedOtherPortals,
  ];

  const allowedAdminHelpDesk = access.some((a) => a.serviceCode === "EUMS");

  return { allowedPortals, allowedAdminHelpDesk };
};

export default useServicePortal;
